var React = require('react');

function FarmConnectLogo (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#008E7F;}\n"),React.createElement("path",{"className":"st0","d":"M84.3,61L47.5,24.2L37.8,34L64.9,61L47.5,78.4L20.4,51.3L10.7,61L42.6,93c2.7,2.7,7,2.7,9.7,0L84.3,61z","key":1}),React.createElement("path",{"className":"st1","d":"M52.3,2c-2.7-2.7-7-2.7-9.7,0L2,42.6c-2.7,2.7-2.7,7,0,9.7l4.9,4.9l13.5-13.5l27.1,27.1l9.7-9.7L30.1,34\n\tl17.4-17.4l40.6,40.6l4.9-4.9c2.7-2.7,2.7-7,0-9.7L52.3,2z","key":2})]);
}

FarmConnectLogo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 95 95","style":{"enableBackground":"new 0 0 95 95"},"xmlSpace":"preserve"};

module.exports = FarmConnectLogo;

FarmConnectLogo.default = FarmConnectLogo;
